package com.downdogapp.client.controllers

import com.downdogapp.*
import com.downdogapp.client.ViewController
import com.downdogapp.client.api.*
import com.downdogapp.client.api.LinkType.MESSAGE
import com.downdogapp.client.singleton.App
import com.downdogapp.client.singleton.Network
import com.downdogapp.client.views.MessageView

class MessageViewController(
  val message: Message,
  private val feedbackType: FeedbackType = FeedbackType.OTHER,
  private val sequenceId: String? = null,
  private val sequenceTime: Duration? = null,
  val blockOnBackClicked: Boolean = false,
) : ViewController() {

  private var backClicked = false
  private var feedbackSent = false

  override val view = MessageView(this)

  override fun onPopped() {
    App.closeKeyboard()
  }

  override fun onViewBecameVisible() {
    logEvent("message_seen", mapOf("id" to message.id))
  }

  fun linkClicked() {
    val link = message.link!!
    logEvent("message_link_clicked", mapOf("id" to link.id))
    Network.post(RecordLinkClickedRequest(id = link.id, linkType = MESSAGE))
    onBackClicked()
    App.openFirstValidUrl(link.urls)
    // FIXME [Android] App becomes unusable (stuck on full screen spinner) after backing out of the "Open With" popup for the link.
    // Immediately after backgrounding the app and then returning to it, the spinner hides and things work again.
  }

  fun submitClicked() {
    if (feedbackSent) {
      return
    }
    App.closeKeyboard()
    val feedback = view.feedback
    if (!feedback.isNullOrEmpty() && feedback != message.feedbackHintText) {
      logEvent("submitted_feedback")
      Network.post(
        RecordFeedbackRequest(
          text = feedback,
          sequenceTime = sequenceTime,
          messageId = message.id,
          sequenceId = sequenceId,
          feedbackType = feedbackType
        )
      )
      feedbackSent = true
      view.feedbackSent()
      App.runAfter(seconds(1.5)) {
        onBackClicked()
      }
    } else {
      onBackClicked()
    }
  }

  override fun onBackClicked() {
    if (!blockOnBackClicked && !backClicked) {
      backClicked = true
      App.closeKeyboard()
      super.onBackClicked()
    }
  }
}
